import DeliveryPaymentContainer from './delivery-payment-container';

export default DeliveryPaymentContainer;